import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spin, message } from "antd";

import NewsletterTemplateForm from "./NewsletterTemplateForm";
import useNewsletterTemplatesAdmin from "hooks/web-templates/useNewsletterTemplatesAdmin";

export default function NewsletterTemplateEditorPage() {
  const { id } = useParams(); // present when editing, undefined when creating
  const navigate = useNavigate();
  const { getTemplateById, createTemplate, updateTemplate } =
    useNewsletterTemplatesAdmin();

  const isEditing = Boolean(id);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(isEditing);

  useEffect(() => {
    if (!isEditing) return;
    (async () => {
      try {
        const fetched = await getTemplateById(id);
        setTemplate(fetched);
      } catch (err) {
        message.error("Failed to load template");
        navigate("/ovizia/newsletter-templates");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (values) => {
    try {
      if (isEditing) {
        await updateTemplate(id, values);
      } else {
        await createTemplate(values);
      }
      navigate(-1);
    } catch (err) {
      message.error(
        isEditing ? "Failed to save changes" : "Failed to create template",
      );
      throw err; // re-throw so NewsletterTemplateForm's isSubmitting still resets correctly
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 64 }}>
        <Spin />
      </div>
    );
  }

  return (
    <NewsletterTemplateForm
      initialValues={template || { premium: false }}
      onSubmit={handleSubmit}
      submitLabel={isEditing ? "Save Changes" : "Create Template"}
      isEditing={isEditing}
    />
  );
}
